import classes from "./Button.module.scss";
import * as React from "react";
import classNames from "classnames";
import { LoadingSpinnerBtn } from "../Spinner/LoadingSpinnerBtn";

export type ButtonProps = {
  content?: string;
  children?: React.ReactNode;
  btnStyle?: "blue" | "white";
  type?: React.ButtonHTMLAttributes<HTMLButtonElement>["type"];
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  isLoading?: boolean;
  isDisabled?: boolean;
  isDeleteBtn?: boolean;
  className?: string;
};
export const Button = ({
  content,
  children,
  btnStyle,
  type,
  disabled,
  onClick,
  isLoading,
  isDisabled,
  isDeleteBtn,
  className,
}: ButtonProps) => {
  const resolvedDisabled = disabled ?? Boolean(isLoading || isDisabled);

  return (
    <button
      type={type ?? "button"}
      disabled={resolvedDisabled}
      className={classNames(classes.normal, className, {
        [classes.active]: btnStyle === "blue",
        [classes.isDisabled]: isDisabled,
        [classes.delete]: isDeleteBtn,
      })}
      onClick={onClick}
    >
      {!isLoading && (children ?? content)}
      {isLoading && <LoadingSpinnerBtn />}
    </button>
  );
};
